import * as types from './types';

const currentUserReceived = currentUser => ({
  type: types.CURRENT_USER_RECEIVED,
  payload: {
    currentUser
  }
});

export { currentUserReceived };
